import type { Reaction } from '../protocol'
import type { EndReason } from './protocol'

/** Every house bot's player id starts with this; a real `players` row exists for each on the server. */
export const CPU_ID_PREFIX = 'cpu:'

export function isCpu(id: string | null | undefined): boolean {
  return typeof id === 'string' && id.startsWith(CPU_ID_PREFIX)
}

/** Sent once, the moment a holdable position becomes a forced loss for the human. */
export const CPU_BLUNDER_REACTION: Reaction = 'wow'

/** Per-bot notion of "over quickly" and "a real fight", in plies. */
export interface CpuThresholds {
  quickPlies: number
  longPlies: number
}

/** What a bot says when a game ends, judged by how the human went down (or didn't). */
export function cpuReactionFor(
  fin: {
    endReason: EndReason
    moveCount: number
    /** The human took the game. */
    humanWon?: boolean
  },
  t: CpuThresholds,
): Reaction {
  if (fin.humanWon) return 'cry'
  switch (fin.endReason) {
    case 'draw':
      return 'clap'
    case 'abandon':
      return 'cry'
    case 'timeout':
      return 'think'
    case 'line':
      if (fin.moveCount <= t.quickPlies) return 'lol'
      return fin.moveCount >= t.longPlies ? 'clap' : 'fire'
  }
}
